import { render, staticRenderFns } from "./RelationDetails.vue?vue&type=template&id=435b7bca&"
import script from "./RelationDetails.vue?vue&type=script&lang=js&"
export * from "./RelationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports